import { TapEventsController } from './tap-events.controller';
import { TapEventsListController } from './list/tap-events-list.controller';
import { IControllerConstructor } from 'angular';

/**
 * The entry point the tap events module
 */
export const initialise = () => {

  angular.module('app.tap-events', [
    'pascalprecht.translate',
    'actora.services',
    'app.layout',
    'app.components',
    
  ]).config(['$stateProvider', '$urlRouterProvider', '$locationProvider', ($stateProvider, $urlRouterProvider, $locationProvider) => {
    $locationProvider.hashPrefix('');

    $stateProvider.state('tap-events', {
      url: '/tap-events',
      templateUrl: 'app/angularJS/features/abt/tap-events/tap-events.html',
      controller: 'TapEventsController',
      controllerAs: 'vm',
      parent: 'common'
    }).state('tap-events-list', {
      url: '/tap-events-list',
      templateUrl: 'app/angularJS/features/abt/tap-events/list/tap-events-list.html',
      controller: 'TapEventsListController',
      controllerAs: 'vm',
      params: {
        tapEvents: undefined
      },
      parent: 'common'
    });

    $urlRouterProvider.otherwise('/');
  }])
  .controller('TapEventsController', <IControllerConstructor>TapEventsController)
  .controller('TapEventsListController', <IControllerConstructor>TapEventsListController);
};